import { Component, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface SaveChangesResult {
  confirmed: boolean;
  comment?: string;
}

@Component({
  selector: 'app-save-changes-modal',
  templateUrl: './save-changes-modal.component.html',
  styleUrls: ['./save-changes-modal.component.css'],
})
export class SaveChangesModalComponent {
  @Output() onClose = new EventEmitter<SaveChangesResult>();

  commentForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef    
  ) {
    this.commentForm = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(150)]],
    });
  }

  close(confirmed: boolean) {
    this.onClose.emit({
      confirmed,
      comment: this.commentForm.value.comment,
    });
    this.bsModalRef.hide();
  }

  onConfirm() {
    if (this.commentForm.invalid) return;
    this.close(true);
  }
}
